import { combineReducers } from 'redux';
import { reducers as filtersListApiHOC } from './FiltersListApiHOC';
import { reducers as productsListApiHOC } from './ProductsListApiHOC';
import { reducers as productApiHOC } from './ProductApiHOC';
import { reducers as addProductApiHOC } from './AddProductApiHOC';
import { reducers as ordersApiHOC } from './OrdersApiHOC';

export default combineReducers({
  filtersListApiHOC,
  productsListApiHOC,
  productApiHOC,
  addProductApiHOC,
  ordersApiHOC,
});



// WEBPACK FOOTER //
// ./src/components/apiHOCs/reducers.js